export enum NoteTypes {
    COMPLIANCE_ITEM = 0,
    USER_CYCLE = 1,
    USER_REQUEST = 2
}